import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { RegionService } from "../services/RegionService";
import { RegionData } from "../types/Types";
import { RegionPickerModal } from "./RegionPickerModal";
import "../styles/TrendingRegions.css";
import "../App.css";

export const TrendingRegions = () => {
  const [regions, setRegions] = useState<RegionData[]>([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const loadRegions = async () => {
      const data = await RegionService.fetchTrendingRegions();
      setRegions(data);
      setLoading(false);
    };

    loadRegions();
  }, []);

  const handleNavigate = (alias: string) => {
    navigate(`/region/${alias}`);
  };

  return (
    <section className="trending-regions-section">
      <RegionPickerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      <div className="trending-regions-header">
        <h2 className="scrollable-feed-header">Regions</h2>

        <button
          onClick={() => setIsModalOpen(true)}
          className="scrollable-feed-btn"
        >
          Go To Region <ChevronRight size={16} />
        </button>
      </div>

      <div className="trending-regions-scroll-container">
        {loading
          ? Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="skeleton-card">
                <div className="skeleton skeleton-image"></div>
                <div className="skeleton skeleton-text"></div>
              </div>
            ))
          : regions.map((region) => (
              <div
                key={region.id}
                className="trending-regions-card"
                onClick={() => handleNavigate(region.regionNameAlias)}
              >
                <div
                  className="trending-regions-card-image"
                  style={{ backgroundImage: `url(${region.coverArtUrl})` }}
                >
                  <div className="trending-regions-map-overlay"></div>
                  <img
                    className="trending-regions-overlay-img"
                    src={region.regionImage}
                    alt={region.regionName}
                  />
                </div>
                <div className="trending-regions-card-info">
                  <h3>{region.regionName}</h3>
                </div>
              </div>
            ))}
      </div>
    </section>
  );
};

